// extracted by mini-css-extract-plugin
module.exports = {"external-link":"ExternalLink_external-link__mXUX6","secondary":"ExternalLink_secondary__MV2BJ","icon":"ExternalLink_icon__kCFeM"};